import React from 'react';

import PriceWithSpecialPrice from '../../../PriceWithSpecialPrice/PriceWithSpecialPrice';
import { FilterResult } from '../../Types';
import InfoBadge from './Components/Badges/InfoBadge';
import SkinAnalysisBadge from './Components/Badges/SkinAnalysisBadge';

interface Props {
    product: FilterResult;
}
const ProductSlideComponent: React.FunctionComponent<Props> = (props) => {
    return (
        <a href={props.product.link} className="product-slider__slide slider__slide">
            <h3 className="product-slider__title h4">{props.product.label}</h3>
            <InfoBadge
                isDiscounted={props.product.isDiscounted}
                isNew={props.product.isNew}
                savingPercent={props.product.savingPercent}
            />
            <img
                src={props.product.imageUri}
                width="166"
                height="166"
                // prevent slider from calculating wrong height while image is still loading
                // this happens because of a faulty imagesLoaded implementation within the React
                // flickity wrapper component
                style={{ height: '166px' }}
                className="product-slider__image"
            />
            <div className="product-slider__price">
                <PriceWithSpecialPrice price={props.product.price} specialPrice={props.product.specialPrice} />
                {props.product.baseQuantity === 'l' || props.product.baseQuantity === 'kg' ? (
                    <div className="product-slider__volume-and-base-price">
                        {props.product.volume}&nbsp;({props.product.basePrice}&nbsp;/&nbsp;{props.product.baseQuantity})
                    </div>
                ) : (
                    <div className="product-slider__volume-and-base-price">{props.product.volume}</div>
                )}
                {props.product.isInStock === false ? (
                    <p className="product-not-available">
                        <svg className="icon icon--warning">
                            <use xlinkHref="#icon-warning" />
                        </svg>
                        Derzeit nicht verfügbar
                    </p>
                ) : null}
            </div>
            <SkinAnalysisBadge customerSpecificData={props.product.customerSpecificData} alignment="center" />
        </a>
    );
};

export default ProductSlideComponent;
